export default "__VITE_ASSET__VNSvC_8c__"